import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ProductService} from '../../../resources/services/product.service';
import {ValidateService} from '../../../resources/modules/validate/validate.service';
import {ToastrService} from 'ngx-toastr';
import {FormService} from '../../../resources/services/form.service';
import {MessageService} from '../../../resources/services/message.service';
import {FormEntityExtension} from '../../../resources/extensions/form-entity-extension/form-entity.extension';
import {PermissionService} from '../../../resources/services/permission.service';
import {FormEntityExtensionService} from "../../../resources/extensions/form-entity-extension/form-entity-extension.service";

@Component({
  selector: 'store-form',
  templateUrl: './store-form.component.html'
})
export class StoreFormComponent extends FormEntityExtension implements OnInit {

  constructor(protected formEntityExtensionService: FormEntityExtensionService,
              private permissionService: PermissionService,) {
    super(formEntityExtensionService);
  }

  productQuery: any = {
    type: 'Subscription'
  };


  ngOnInit(): void {
    let form = new FormBuilder().group({
        name: ['', Validators.required],
        key: ['', Validators.required],
        applePackageName: [''],
        googlePackageName: [''],
        description: [''],
    });
    if (this.permissionService.get('StoreKeyComponent')) {
        form.addControl('storeKey', new FormControl())
    }
    this.initForm(
        form
    );
  }
}
